import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

const getCanaryDownloadInfo = (state: RootState) => state.canaryDownload;

export const getIsRecordingCanaries = createSelector(getCanaryDownloadInfo, (info) => info.recording);

export const getExcavations = createSelector(getCanaryDownloadInfo, (info) => info.excavations);
